export const COLORS = {
    textPrimary: '#343D4C',
    textSecondary: '#6D7C99',
    textMuted: '#808080',
    textBody: '#666',
    border: '#D9D9D9',
    borderLight: '#EDEDED',
    surfaceMuted: '#F6F6F6',
    unreadBg: '#F0F7FF',
    defaultTheme: '#203554',
    cardBg: '#fff',
    white: '#fff',
};

export const SHADOWS = {
    card: 'rgba(0, 0, 0, 0.05) 0px 4px 24px 1px',
};

export const GRADIENTS = {
    imageOverlay: 'linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 37.13%)',
};

export const FONT_SIZES = {
    listTitle: '40px',
};
